// Network paths the sign-up flow reaches outside @twg/api-client. Account creation,
// email-exists and availability go through createPublicClient (frontend/api-client); the
// Google OAuth URL is built in useSignupAuth; LocationIQ lives in useAddressAutocomplete.
export const ENDPOINTS = {
  // Legacy session-lane tracking endpoint: Api::TrackingController#create reads
  // { event_name, properties } and derives the device id server-side.
  tracking: '/api/tracking',
} as const
